
import type { SetupContext } from 'vue'

import type FiltersAside from '../../../components/filters/filters-aside.component.vue'
import { defineComponent, ref, watch } from 'vue'
import ExplainFiltersAside from '../../../components/explain/explain-filters-aside.component.vue'
import ExplainQueryAnalysisHeader from '../../../components/explain/explain-query-analysis/header.component.vue'
import SearchData from '../../../components/explain/explain-query-analysis/search-data.component.vue'
import SearchMetrics from '../../../components/explain/explain-query-analysis/search-metrics.component.vue'
import ExplainSectionLayout from '../../../components/explain/explain-section-layout.component.vue'
import EpbInlineTabs from '../../../components/shared/epb-inline-tabs/epb-inline-tabs.component.vue'
import { useContextQuery } from '../../../composables/use-context-query/index'
import { useEpb } from '../../../composables/use-epb'
import { useExplainFilters } from '../../../composables/use-explain-filters'
import { useExplainPdfDownload } from '../../../composables/use-explain-pdf-download'
import { useExplainSectionsConfig } from '../../../composables/use-explain-sections-config'
import { ExplainSectionEnum } from '../../../enums/explain-section.enum'

export default defineComponent({
  name: 'ExplainQueryAnalysis',
  components: {
    EpbInlineTabs,
    ExplainSectionLayout,
    ExplainQueryAnalysisHeader,
    ExplainFiltersAside,
  },
  async beforeRouteLeave(to, from, next) {
    if (this.query) {
      this.contextWatchDisabled = true
      await this.clearQuery()
    }

    next()
  },
  setup(_, { emit }: SetupContext) {
    const contextWatchDisabled = ref(false)
    const filtersAside = ref<InstanceType<typeof FiltersAside>>()

    const { $epb } = useEpb()
    const { query, clearQuery } = useContextQuery()
    const { currentSectionConfig } = useExplainSectionsConfig(ExplainSectionEnum.QUERY_ANALYSIS)
    const { filters, showExplainFilters, showExplainFiltersAside } = useExplainFilters({
      areAllFiltersMandatory: currentSectionConfig.value.areAllFiltersMandatory,
    })

    watch(query, () => {
      if (!contextWatchDisabled.value) {
        // Updates the query in the URL
        emit('contextChanged')
      }
    })
    const messages = $epb.messages.explain

    const queryAnalysisTabs = [
      {
        id: 'SEARCH_METRICS',
        label: messages.queryAnalysis.sections.searchMetrics.label,
        component: SearchMetrics,
      },
      {
        id: 'SEARCH_DATA',
        label: messages.queryAnalysis.sections.searchData.label,
        component: SearchData,
      },
    ]

    const { creatingPdf, downloadExplainPdf } = useExplainPdfDownload()

    function openFilters(): void {
      filtersAside.value.open()
    }

    return {
      query,
      clearQuery,
      filters,
      showExplainFilters,
      showExplainFiltersAside,
      ExplainSectionEnum,
      messages,
      queryAnalysisTabs,
      openFilters,
      contextWatchDisabled,
      filtersAside,
      creatingPdf,
      downloadExplainPdf,
    }
  },
})
